<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 11:23:33
 * @LastEditors: whaoo
 * @LastEditTime: 2023-11-10 13:44:19
-->
<template>
  <div class="device_data" :style="'height:' + (bodyHeight) + 'px'">
    <!-- <div class="data_tab">
      <div class="tab_item" :class="{ active_tab: active == 1 }" @click="active = 1">心率</div>
      <div class="tab_item" :class="{ active_tab: active == 2 }" @click="active = 2">血氧</div>
    </div>
    <highcharts v-show="active == 1" :options="hrChartOptions"></highcharts>
    <highcharts v-show="active == 2" :options="spo2ChartOptions"></highcharts> -->
    <div class="search_box">
      <div class="search_item">
        <div class="left_lable">患者住院号：</div>
        <div class="right_input">
          <el-input v-model="patient_id" disabled></el-input>
        </div>
      </div>
      <div class="search_item">
        <div class="left_lable">数据采集时间：</div>
        <div class="right_input">
          <el-select v-model="date" @change="changeDate" :popper-append-to-body="false">
            <el-option v-for="(item, index) in dateList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="search_btn" @click="getChartData">
        搜索
      </div>
    </div>

    <div class="flex_box psr">
      <img src="../assets/logo.png" class="logo" alt="" srcset="">

      <div class="data_left">
        <div class="left_title">体征数据</div>
        <div class="data_box">
          <div class="data_title flex_box">
            <img src="../../static/hr.png">
            <div style="width: 3.2rem;">心率</div>
            <div>次/分</div>
          </div>
          <div class="new_value">{{ body_data.hr.value ? body_data.hr.value : '--' }}</div>
          <div class="detail_data flex_box">
            <div>
              <div class="value">{{ body_data.hr.value ? body_data.hr.average_avg : '--' }}</div>
              <div class="text">平均心率</div>
            </div>
            <div>
              <div class="value">{{ body_data.hr.value ? body_data.hr.average_max : '--' }}</div>
              <div class="text">最大心率</div>
            </div>
            <div>
              <div class="value">{{ body_data.hr.value ? body_data.hr.average_min : '--' }}</div>
              <div class="text">最小心率</div>
            </div>
          </div>
        </div>
        <div class="data_box">
          <div class="data_title flex_box">
            <img src="../../static/spo2.png">
            <div style="width: 3.2rem;">血氧饱和度</div>
            <div>%</div>
          </div>
          <div class="new_value">{{ body_data.hr.value ? body_data.spo2.value : '--' }}</div>
          <div class="detail_data flex_box">
            <div>
              <div class="value">{{ body_data.hr.value ? body_data.spo2.average_avg : '--' }}</div>
              <div class="text">平均血氧</div>
            </div>
            <div>
              <div class="value">{{ body_data.hr.value ? body_data.spo2.average_max : '--' }}</div>
              <div class="text">最大血氧</div>
            </div>
            <div>
              <div class="value">{{ body_data.hr.value ? body_data.spo2.average_min : '--' }}</div>
              <div class="text">最小血氧</div>
            </div>
          </div>
        </div>
      </div>
      <div class="data_right">
        <div class="tab_box" v-if="dateList.length > 0">
          <div class="tab_item" :class="{ active_tab: active == 1 }" @click="tab_change(1)">心率</div>
          <div class="tab_item" :class="{ active_tab: active == 2 }" @click="tab_change(2)">血氧</div>
        </div>
        <div class="data_chart" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)" v-if="haveChartData">
          <div class="nowchoose">
            <div>{{ active == 1 ? nowchoosehr.name : nowchoosespo2.name }}</div>
            <div><span>{{ active == 1 ? nowchoosehr.y : nowchoosespo2.y }}</span>{{ active == 1 ? '次/分' : "%" }}</div>
          </div>
          <highcharts v-show="active == 1" style="height:5.06rem" :options="hrChartOptions"></highcharts>
          <highcharts v-show="active == 2" style="height:5.06rem" :options="spo2ChartOptions"></highcharts>
        </div>
        <div class="nodata" v-else>
          <img src="../../static/nodata.png" alt="">
          <div class="nodata_text">
            {{ device.ccid ? (patient_id ? '暂无数据，请提醒患者坚持佩戴久乐表' : "当前床位暂无患者") : '当前床位暂未绑定久乐表，请先绑定久乐表' }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import { highcharts } from 'highcharts-vue'
import Highcharts from 'highcharts'
import axios from 'axios'
import { Loading } from 'element-ui';


export default {
  data() {
    const _this = this
    return {
      active: 1,
      hrChartOptions: {
        loading: {
          hideDuration: 1000,
          showDuration: 1000,
          labelStyle: {
            fontStyle: 'italic'
          }
        },
        credits: {
          enabled: false,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value: %H:%M}',
          },
          tickPixelInterval: 90,
        },
        yAxis: [{
          title: {
            text: '',
            style: {
              color: '#CCCCCC'
            }
          },
          labels: {

          },
          tickPixelInterval: 50,
          min: 0,
        }],
        legend: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
          shared: true,
          //followPointer:true,
          followTouchMove: true,
          valueSuffix: '次/分',
          borderColor: '#4c83f6',
          borderRadius: 10,
          crosshairs: {
            width: 1,
            color: '#4c83f6',
          },
          positioner: function (labelWidth, labelHeight, point) {
            var px = point.plotX,
              pw = this.chart.xAxis[0].width;

            if (px > pw - labelWidth + this.chart.plotLeft) {
              px = pw - labelWidth + this.chart.plotLeft;
            }

            if (px < labelWidth / 2) {
              px = 0;
            }

            return {
              x: px,
              y: 0
            };
          },
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 1
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            crisp: false,
            turboThreshold: 200000,//添加这一句，如果设置为0，则取消此项检查
            point: {
              events: {
                mouseOver: function () {
                  _this.nowchoosehr = this.options
                }
              }
            }
          },
        },
        series: [{
          type: 'area',
          name: '心率',
          data: [],
          color: Highcharts.getOptions().colors[0],
          fillColor: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0.2).get()],
              [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get()]
            ]
          }
        }]
      },
      spo2ChartOptions: {
        loading: {
          hideDuration: 1000,
          showDuration: 1000,
          labelStyle: {
            fontStyle: 'italic'
          }
        },
        credits: {
          enabled: false,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value: %H:%M}',
          },
          tickPixelInterval: 90,
        },
        yAxis: [{
          plotLines: [{
            color: 'black',
            dashStyle: 'dash',
            width: 1,
            value: 80,
            label: {
              align: 'left',
              style: {
                fontStyle: 'italic'
              },
              text: '血氧预警阈值',
            },
            zIndex: 3
          }],
          title: {
            text: '',
            style: {
              color: '#CCCCCC'
            }
          },
          labels: {
            formatter: function () {
              return (this.value) + "%";
            }
          },
          tickPositions: [0, 50, 100]
        }],
        legend: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
          shared: true,
          //followPointer:true,
          followTouchMove: true,
          valueSuffix: '%',
          borderColor: '#4c83f6',
          borderRadius: 10,
          crosshairs: {
            width: 1,
            color: '#4c83f6',
          },
          positioner: function (labelWidth, labelHeight, point) {
            var px = point.plotX,
              pw = this.chart.xAxis[0].width;

            if (px > pw - labelWidth + this.chart.plotLeft) {
              px = pw - labelWidth + this.chart.plotLeft;
            }

            if (px < labelWidth / 2) {
              px = 0;
            }

            return {
              x: px,
              y: 0
            };
          },
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 1
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            crisp: false,
            turboThreshold: 200000,//添加这一句，如果设置为0，则取消此项检查
            point: {
              events: {
                mouseOver: function () {
                  _this.nowchoosespo2 = this.options
                }
              }
            }
          }
        },
        series: [{
          type: 'area',
          name: '血氧饱和度',
          data: [],
          color: Highcharts.getOptions().colors[0],
          fillColor: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0.2).get()],
              [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get()]
            ]
          }
        }]
      },
      patient_id: "13232131",
      date: "",
      dateList: [
      ],
      body_data: {
        spo2: {},
        hr: {}
      },
      device: {},
      haveChartData: false,
      loadingOptions: {
        target: ".device_data",
        lock: true,
        text: '加载中···',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      },
      loading: undefined,
      bodyHeight: 0,
      nowchoosehr: {
        x: "",
        y: ""
      },
      nowchoosespo2: {
        x: "",
        y: ""
      },
      chartLoading: undefined,
      bed: '',
      room: "",
      zone: "",
      patient_id: "",
      start: ""
    };
  },
  mounted() {
    // this.getHrData()
    let that = this
    that.bodyHeight = window.innerHeight;
    window.onresize = () => {
      return (() => {
        that.bodyHeight = window.innerHeight;
      })();
    };
    const query = this.$route.query

    this.patient_id = query.inpatientCode
    this.bed = query.bedNumber
    this.room = query.roomNumber
    this.zone = query.zoneNumber
    this.getDeviceList({
      bed_number: this.bed,
      room_number: this.room
    })

  },

  methods: {
    getDeviceList(data) {
      axios({
        url: process.env.BASE_API + 'api/hope/list',
        method: 'post',
        data,
      }).then(res => {
        if (res.data.status == 200) {
          if (res.data.result.length && res.data.result[0].bind == 1) {
            this.device = res.data.result[0]
            this.getPatientDate()
          } else {
            this.device = {}
          }
          console.log(this.device_list);

        }
        else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changeDate(e) {
      // this.getChartData()
    },
    getChartData() {
      if (this.dateList.length == 0) {
        return
      }
      this.chartLoading = Loading.service(this.loadingOptions);
      // this.chartLoading = true
      this.body_data = {
        spo2: {},
        hr: {}
      }
      this.getHrData()
      this.getSpo2Data()
    },
    getHrData() {
      let data = {
        name: 'heartrate',
        from: new Date(this.date + ' 00:00:00').getTime() / 1000,
        to: new Date(this.date + ' 23:59:59').getTime() / 1000,
        ccid: this.device.ccid,
      }
      this.dateList.forEach((item, index) => {
        if (item.value == this.date && index == 0) {
          data.from = this.start
        }
      })
      axios({
        url: process.env.BASE_API + 'api/output/report',
        method: 'get',
        params: data
      }).then(res => {
        if (res.data.status == 200) {
          this.chartLoading.close()
          if (res.data.result.list.length) {
            this.setHrOptions(res.data)
            this.haveChartData = true
            this.body_data.hr = res.data.result.avg

            for (let index = res.data.result.list.length - 1; index > 0; index--) {
              const element = res.data.result.list[index];
              if (element.y) {
                this.nowchoosehr = element
                this.body_data.hr.value = element.y
                return
              }
            }
          } else {
            this.haveChartData = false
          }

        }
        else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    getSpo2Data() {
      let data = {
        name: 'spo2',
        from: new Date(this.date + ' 00:00:00').getTime() / 1000,
        to: new Date(this.date + ' 23:59:59').getTime() / 1000,
        ccid: this.device.ccid,
      }
      // console.log(this.start);
      this.dateList.forEach((item, index) => {
        if (item.value == this.date && index == 0) {
          data.from = this.start
        }
      })
      axios({
        url: process.env.BASE_API + 'api/output/report',
        method: 'get',
        params: data
      }).then(res => {
        if (res.data.status == 200) {
          if (res.data.result.list.length) {
            this.setSpo2Options(res.data)
            this.haveChartData = true
            for (let index = res.data.result.list.length - 1; index > 0; index--) {
              const element = res.data.result.list[index];
              this.body_data.spo2 = res.data.result.avg
              if (element.y) {
                this.body_data.spo2.value = element.y
                this.nowchoosespo2 = element
                return
              }
            }
          } else {
            this.haveChartData = false
          }
        }
        else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    setHrOptions(json) {
      this.hrChartOptions.series[0].data = json.result.list
    },
    setSpo2Options(json) {
      this.spo2ChartOptions.series[0].data = json.result.list
      this.spo2ChartOptions.yAxis[0].plotLines[0].value = this.device.spo2
      this.spo2ChartOptions.yAxis[0].plotLines[0].label.text = '血氧预警阈值：'+this.device.spo2
    },
    tab_change(active) {
      if (active == this.active) {
        return
      }
      this.active = active
    },
    getPatientDate() {
      // this.date='2023年10月11日 星期三'
      this.date = ''
      this.dateList = []
      if (this.patient_id) {
        let data = {
          patient_id: this.patient_id,
          bed_number: this.bed,
          room_number: this.room,
          zone_number: this.zone,
          // patient_id:this.patient_id
        }
        axios({
          url: process.env.BASE_API + 'api/hope/time',
          method: 'post',
          data,
        }).then(res => {
          if (res.data.status == 200) {
            // this.loading.close();
            if (res.data.result.start) {
              this.start = res.data.result.start
              let weekList = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六',]
              let startDate = new Date(this.$dateFtt.dateFtt('yyyy/MM/dd 00:00:00', new Date(res.data.result.start * 1000))).getTime()
              let endDate = res.data.result.end ? res.data.result.end * 1000 : new Date().getTime()
              let dateArr = this.$dateFtt.getAllDate(startDate, endDate)
              dateArr.forEach(item => {
                this.dateList.push(
                  {
                    label: `${this.$dateFtt.dateFtt('yyyy年MM月dd日', item)} ${weekList[item.getDay()]}`,
                    value: this.$dateFtt.dateFtt('yyyy/MM/dd', item)
                  }

                )
              })
              this.date = this.dateList[this.dateList.length - 1].value
              this.getChartData()
            }

          }
          else if (res.data.message != '获取时间失败') {
            this.$message.error(res.data.message)
          }
        }).catch(err => {
          console.log(err);
          this.$message.error(err.message)
        })
      }
    }
  }
}

</script>
<style  scoped>
@import url('../assets/device_data.css');
/* .data_tab {
  display: flex;
}

.tab_item {
  margin-right: 20px;
  cursor: pointer;
}

.active_tab {
  color: blue;
} */
</style>


// WEBPACK FOOTER //
// src/view/device_data.vue